import React from 'react'

import { number } from 'prop-types'

const amountToNextLevel = (nextLevelGmvThreshold, annualRevenue) => (nextLevelGmvThreshold - annualRevenue).toFixed(2)

function DefaultRoyaltyBox({
  annualRevenue,
  levelRoyaltyRate,
  levelId,
  nextLevelRoyaltyRate,
  nextLevelGmvThreshold,
}) {
  return (
    <div className="overview__royalty-box-wrapper">
      <div className="overview__royalty-box">
        <div className="overview__royalty-box-title">
          Sales in the last 365 days -{' '}
          <span className="overview__royalty-box-sales">${annualRevenue}</span>
        </div>

        <div className="overview__royalty-box-row">
          Your current payout rate is <b>{levelRoyaltyRate || 0}%</b>.
        </div>

        {levelId < 26 && (
          <div className="overview__royalty-box-next">
            Sell an additional{' '}
            <b>${amountToNextLevel(nextLevelGmvThreshold, annualRevenue)}</b> to
            reach the next level and start earning{' '}
            <b>{nextLevelRoyaltyRate || 0}%</b> on each sale!
          </div>
        )}
      </div>
    </div>
  )
}

DefaultRoyaltyBox.propTypes = {
  annualRevenue: number.isRequired,
  levelRoyaltyRate: number.isRequired,
  levelId: number.isRequired,
  nextLevelRoyaltyRate: number.isRequired,
  nextLevelGmvThreshold: number.isRequired,
}

export default DefaultRoyaltyBox
